/**
 * `entities/taxonomy` query options factories.
 *
 * `assetsHttp` auto-injects the `x-selected-workspace-id` header, so workspace
 * context is implicit.
 *
 * URL prefix `/api/v1` matches the assets-api URI versioning
 * (`setupApiVersioning`: prefix `api/v`, default version `1`).
 */
import { queryOptions } from '@tanstack/react-query';
import { assetsHttp } from '@/lib/api/http-client';
import { parseResponse } from '@/lib/api/parse-response';
import { TAXONOMY_QUERY_KEYS } from './query-keys';
import { taxonomyChangeLogSchema, taxonomySchema, taxonomySummaryListSchema } from './schemas';

const TAXONOMIES_URL = '/api/v1/taxonomies';

export const taxonomiesQueryOptions = () =>
  queryOptions({
    queryKey: TAXONOMY_QUERY_KEYS.list(),
    queryFn: async ({ signal }) => {
      const response = await assetsHttp.get({ throwOnError: true, url: TAXONOMIES_URL, signal });
      return parseResponse(taxonomySummaryListSchema, response);
    },
  });

export const taxonomyDetailQueryOptions = (id: string) =>
  queryOptions({
    queryKey: TAXONOMY_QUERY_KEYS.detail(id),
    queryFn: async ({ signal }) => {
      const response = await assetsHttp.get({
        throwOnError: true,
        url: `${TAXONOMIES_URL}/{id}`,
        path: { id },
        signal,
      });
      return parseResponse(taxonomySchema, response);
    },
  });

export const taxonomyChangeLogQueryOptions = (id: string) =>
  queryOptions({
    queryKey: TAXONOMY_QUERY_KEYS.changeLog(id),
    queryFn: async ({ signal }) => {
      const response = await assetsHttp.get({
        throwOnError: true,
        url: `${TAXONOMIES_URL}/{id}/change-log`,
        path: { id },
        signal,
      });
      return parseResponse(taxonomyChangeLogSchema, response);
    },
  });
